import React, { PureComponent } from 'react'
import Immutable from 'seamless-immutable'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import { connect } from 'react-redux'
import ItemSummary from '../components/ItemSummary'
import { withErrorBoundary } from '../errors/ErrorBoundary'
import { landCoverMetadata } from '../config/landCover'

const styles = theme => ({
  container: {
    position: 'absolute',
    top: '75px',
    right: '85px'
  }
})

const demos = {
  146463: {
    'well name': 'Demo 1',
    'spud date': '2010-08-09',
    'licensee': 'Acme',
    'license #': '0081929'
  },
  146190: {
    'well name': 'Demo 2',
    'spud date': '2012-03-17',
    'licensee': 'Acme',
    'license #': '2041449'
  },
  147247: {
    'well name': 'Demo 3',
    'spud date': '2009-04-12',
    'licensee': 'Acme',
    'license #': '4583581'
  },
  147331: {
    'well name': 'Demo water',
    'spud date': '2010-08-09',
    'licensee': 'Acme',
    'license #': '0111384'
  },
  147412: {
    'well name': 'Demo vegetation',
    'spud date': '2003-09-22',
    'licensee': 'Acme',
    'license #': '2581449'
  }
}

const formatNumber = (value, decimals) => {
  return Number(Number(value).toFixed(decimals)).toLocaleString()
}

const iceDriftFormats = {
  deltatime_hrs: {
    label: 'Delta time (hrs)',
    transform: item => item.toFixed(1).toLocaleString()
  },
  disp_m: {
    label: 'Displacement (m)',
    transform: item => formatNumber(item, 0)
  },
  speed_ms: {
    label: 'Velocity (m/s)',
    transform: item => formatNumber(item, 3)
  },
  timestamp1: {
    label: 'Reference'
  },
  timestamp2: {
    label: 'Match'
  }
}

class ItemSummaryFloatContainer extends PureComponent {
  render () {
    const { classes, data, id } = this.props

    if (!data) {      
      return null
    }

      if (['IceDriftVector-line', 'IceDriftDisplacement', 'IceDriftVector'].includes(id)) {
      const items = Object.keys(data)
            .filter(key => Object.keys(iceDriftFormats).includes(key))
            .map(key => {
              const format = iceDriftFormats[key]
              const value = format.transform ? format.transform(data[key]) : data[key]
              const label = format.label
              return (
                <ItemSummary title={label} value={value} key={key}/>
              )
            })
      return (
        <div className={classes.container}>
          <Card>
            {items}
          </Card>
        </div>
      )
      } else if (['EnergirMeasures', 'EnergirChange', 'IceDriftVector-line', 'IceDriftVector'].includes(id)) {      
      const items = Object.keys(data)
          .map(key => {
            const value = data[key]
            const label = key
            return (
              <ItemSummary title={label} value={value} key={key}/>
            )
          })
      return (
        <div className={classes.container}>
          <Card>
            {items}
          </Card>
        </div>
      )
    } else {
      const whitelist = ['land_cover', 'ndvi', 'rank', 'wellsite_f', 'Class', 'Area', 'gridcode']
      let items = Object.keys(data)
            .filter(key => whitelist.includes(key))
            .map(key => {
              const title = key
              let value
              let label
              if (key === 'wellsite_f') {
                value = data[key]
                label = 'wellsite id'
              } else if (key === 'land_cover') {
                value = landCoverMetadata.find(item => item.value === data[key]).label
                label = 'land cover'
              } else if (key === 'rank') {
                value = data[key].toFixed(2)
                label = '\u03C3'
              } else if (key === 'ndvi') {
                value = (data[key] / 1000).toFixed(2)
                label = 'ndvi'
              } else if (key === 'Class') {
                value = data[key]
                label = 'Class'
              } else if (key === 'Area') {
                value = `${data[key]/(10**3)} km2`
                label = 'Area'
              } else if (key === 'gridcode' && id == 'river-ice-athabasca') {
                const categories = ['Open water / water on ice', 'Deteriorating', 'Smooth ice', 'Rough ice']
                const index = data[key] - 1
                value = categories[index]
                label = 'Classification: '
              // } else if (key === 'gridcode') {
              //   value = data[key]
                //   label = 'Code: '
              } else if (key === 'gridcode') {
                const categories = ['Open water', 'Water on ice', 'Non-consolidated ice', 'Consolidated ice']
                const index = data[key] < 31 ? data[key] : data[key] - 31
                value = categories[index]
                label = 'Classification: '
                // } else if (key === 'gridcode') {
                //   value = data[key]
                //   label = 'Code: '
              } else {
                value = data[key]
                label = key
              }
              return (
                  <ItemSummary title={label} value={value} key={key}/>
              )
            })
      const { wellsite_f } = data

      if (wellsite_f && Object.keys(demos).includes(wellsite_f.toString())) {
        const meta_data = demos[wellsite_f]

        let meta_items = Object.keys(meta_data)
              .map(key => <ItemSummary title={key} value={meta_data[key]} key={key}/>)
        items = items.concat(<ItemSummary title={'label'} value={'value'} key={'key'}/>)
        items = meta_items.concat(items)
      }

      return (
        <div className={classes.container}>
          <Card>
            {items}
          </Card>
        </div>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { id, ids } = ownProps
  // if (id === 'EnergirMeasures') {
  //   console.log(id)
  //   console.log(Object.keys(state.data))
  //   console.log(state.data.id)
  // }
  const result = ids ?
        ids.reduce((a, b) => {
          const data = state.data[b]
          const next = data ? a.merge(data) : a
          return next
        }, Immutable({})) :
        state.data[id]
  return {    
    data: result
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(ItemSummaryFloatContainer))



// WEBPACK FOOTER //
// ./src/containers/ItemSummaryFloatContainer.js